import { useCurrentGroupFromContext } from "../providers/UserInfoProvider"

export const useCurrentGroup = () => {
  return useCurrentGroupFromContext()
}
